import { AssessmentHistory, AssessmentStatus } from "@store/generalTypes";
import { translate } from "react-i18nify";

export const getEnumKeyByValue = <T extends { [index: string]: string }>(
    enumType: T,
    enumValue: string
): keyof T | undefined => {
    return Object.keys(enumType).find((key) => enumType[key] === enumValue);
};

export const getEnumValueByKey = <T extends { [index: string]: string }>(
    enumType: T,
    enumKey: keyof T | string
): string | undefined => {
    return Object.values(enumType).find((value) => enumType[enumKey] === value);
};

export const parseStatus = (status: AssessmentStatus): string => {
    return status === AssessmentStatus.Started.toLocaleLowerCase()
        ? "Discontinued"
        : getEnumValueByKey(AssessmentStatus, `${status[0].toUpperCase()}${status.slice(1)}`) ?? status;
};

export const parseHistoryStatus = (history: Pick<AssessmentHistory, "status" | "hasExecution">): string => {
    // An older API may omit this field; do not reinterpret historical records without evidence.
    if (history.hasExecution === false && history.status.toLowerCase() === AssessmentStatus.Started.toLowerCase()) {
        return translate("admin.preAssessmentInitiated");
    }
    return parseStatus(history.status);
};
